import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import NodeRSA from 'node-rsa';
import './ZendeskChatBot.scss';
import instagram from '../image/instagram.svg';
import telegram from '../image/telegram.svg';
import Twitter from '../image/Twitter.svg';
import facebook from '../image/facebook.svg';
import Loader from './Loader';
import { Collapse } from 'antd';

function dissectAnswer(answer) {
  // Split the answer into steps
  const steps = answer.split(/\r?\n/).filter(Boolean);

  // Generate HTML for each step
  return steps.map((step, index) => {
    return <p>{step.trim()}</p>;
  });
}

const ZendeskChatBot = () => {
  const [loading, setLoading] = useState(true);
  const [item, setItem] = useState(true);
  const { state } = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const publicKey = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2wzqlCphAcUFgYRe9zkL
  zTlRlgFdg2Xjvcpd0DHV1AbccXPer26UiKxJOf0oP9MYqndYATHvEK+KhP565uBP
  9ea+IhE7Su7xmI+yhyf3bAY9Ok6OcnkXSg2v9fxBnkWkSCxmMirW5EYFR47U/C0/
  qtx/4/0YykFBlZ215HsgUoH7ACmzvjwQBGYw8u6EJ6E8fW0KYboTbi4NmmfulXQD
  CAiSITsiCU913cxOFRm8m/uBlNyCPOommYyAA4fX0F3CdfCIDKJA3jK5LwKaS8PT
  MMvOHMoMeAoXAQi0Vw3uT1j8BFB7F4uZpUdbD0x9kmT/o4PhIVvYnv8LNSdoQ/rA
  HQIDAQAB
  -----END PUBLIC KEY-----`;

  function encryptAndSignMessage(message) {
    const second = new NodeRSA(publicKey);
    second.setOptions({ encryptionScheme: 'pkcs1' });
    const enc = second.encrypt(message, 'base64');
    const encryptedData = {
      data: enc,
    };
    return encryptedData;
  }

  useEffect(() => {
    const isValidUser = sessionStorage.getItem('validUser');
    if (isValidUser == null || isValidUser == undefined || isValidUser == '') {
      const encryptedData = encryptAndSignMessage({
        wallet_address: state.walletAddress,
      });
      fetch(
        'https://dev-api.atlaswallet.com/dev/api/v1/wallet/validate_chat_boot',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Aw-Api-Auth': 'cd852a1599d929d4fe5546a686a59bca5c1ec3f4',
            Authorization: 'Per26UiKxJUoH7A',
          },
          body: JSON.stringify(encryptedData),
        }
      )
        .then((response) => {
          if (
            response.status == 400 ||
            response.status == 404 ||
            response.status == 500
          ) {
            navigate('/notFound');
          } else {
            const script = document.createElement('script');
            script.id = 'ze-snippet';
            script.src =
              'https://static.zdassets.com/ekr/snippet.js?key=e15542cb-c56e-46bb-aea3-7930d34263a9';
            document.body.appendChild(script);
          }
        })
        .then((data) => {})
        .catch((error) => {
          console.error('Error:', error);
          navigate('/notFound');
        });
    } else {
      if (state) {
        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src =
          'https://static.zdassets.com/ekr/snippet.js?key=e15542cb-c56e-46bb-aea3-7930d34263a9';
        document.body.appendChild(script);
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 6000);
  }, []);

  useEffect(() => {
    const formattedFaqs = state?.data?.map((faq, index) => {
      return {
        key: index + 1,
        label: faq.question,
        children: (
          <div
            style={{ textAlign: 'initial' }}
            dangerouslySetInnerHTML={{
              __html: faq.answer.replaceAll('\r\n', '</br>'),
            }}
          />
        ),
      };
    });
    setItem(formattedFaqs);
  }, []);

  const onChange = (key) => {};
  return (
    <div className='zendeskBot'>
      <div className='helpCenter'>
        <h2
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <svg
            viewBox='0 0 24 24'
            height={30}
            width={30}
            style={{ marginLeft: 10, cursor: 'pointer' }}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            onClick={() => {
              navigate(-1);
            }}
          >
            <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
            <g
              id='SVGRepo_tracerCarrier'
              stroke-linecap='round'
              stroke-linejoin='round'
            ></g>
            <g id='SVGRepo_iconCarrier'>
              {' '}
              <path
                d='M4 10L3.29289 10.7071L2.58579 10L3.29289 9.29289L4 10ZM21 18C21 18.5523 20.5523 19 20 19C19.4477 19 19 18.5523 19 18L21 18ZM8.29289 15.7071L3.29289 10.7071L4.70711 9.29289L9.70711 14.2929L8.29289 15.7071ZM3.29289 9.29289L8.29289 4.29289L9.70711 5.70711L4.70711 10.7071L3.29289 9.29289ZM4 9L14 9L14 11L4 11L4 9ZM21 16L21 18L19 18L19 16L21 16ZM14 9C17.866 9 21 12.134 21 16L19 16C19 13.2386 16.7614 11 14 11L14 9Z'
                fill='#fff'
              ></path>{' '}
            </g>
          </svg>
          Help Center
          <div></div>
        </h2>
      </div>
      <div className='qusAnsSec'>
        <div className='qustionHeading'>
          <h2>{state?.question?.question}</h2>
        </div>
        <div className='qusInner'>{dissectAnswer(state?.question?.answer)}</div>
      </div>
      {/* <Loader loading={loading} /> */}
    </div>
  );
};

export default ZendeskChatBot;
